import { Controller } from 'front-end-core/core/Router'
import Main from 'pages/legislationcategories/Main'
import Header from './Header'
import { LEGISLATION_CATEGORIES } from 'constants/controllers'

export default new Controller({
  name: LEGISLATION_CATEGORIES,
  route: ':aol/legislation/folder',
  controller (
    Router,
    {
      url: pageId,
      scrollMain,
      pageView,
      pageData,
      params: { aol, path = null },
      previousPageId,
      query
    },
    render
  ) {
    render(
      { Main, Header },
      { act: path, scrollMain, aol, query },
      {
        aol,
        pageId,
        searchType: 'legislation',
        className: 'legislation legislation-accordion-namespace'
      }
    )

    return pageId
  }
})
